import { Accordion } from "flowbite-react";
import React from "react";

const DefaultAccordion = ({ data, customClasses = {} }) => {
  const {
    accordionClass = "",
    panelClass = "",
    titleClass = "",
    contentClass = "",
    indexClass = "",
  } = customClasses;

  return (
    <Accordion className={`border-none ${accordionClass}`}>
      {data.map((item, index) => (
        <Accordion.Panel className={`!p-2 ${panelClass}`} key={index}>
          <Accordion.Title
            className={`!p-2 hover:bg-white bg-white rounded-none text-theme ${titleClass}`}
          >
            <div className="flex flex-row gap-2 items-center">
              <span
                className={`bg-gradient-to-r from-[#1E3A8A] to-[#3B82F6] text-white rounded-full !min-h-6 !min-w-6 flex flex-row justify-center items-center ${indexClass}`}
              >
                {index + 1}
              </span>
              <span className="font-bold text-cs">{item.title}</span>
            </div>
          </Accordion.Title>
          <Accordion.Content
            className={`!text-theme !pl-10 dark:text-textLight p-2 text-sm ${contentClass}`}
          >
            <div dangerouslySetInnerHTML={{ __html: item.content }} />
              {item.link && (
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-medium text-sm cursor-pointer underline underline-offset-4 text-theme decoration-theme"
                >
                  Click here to get more detail..
                </a>
              )}
          </Accordion.Content>
        </Accordion.Panel>
      ))}
    </Accordion>
  );
};

export default DefaultAccordion;
